import IframeActivity from "./IframeActivity";

export default function FactsAndValues() {
    return (
        <IframeActivity
            src="/activities/facts-and-values/index.html"
            title="Facts and Values"
        />
    );
}